import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import {
  reviewFilterCategoryOptions,
  reviewFilterCategoryOptionsEnToKrMap,
  reviewManageColumns,
  TReviewFilterCategory,
  useGetAllReviewManageAdminResponse,
} from "./model";
import {
  App,
  Button,
  DatePicker,
  Input,
  Modal,
  Radio,
  Select,
  Switch,
  Table,
} from "antd";
import { CSVLink } from "react-csv";

const ReviewManage = () => {
  const all: [null, null] = [null, null];
  const today: [Dayjs, Dayjs] = [dayjs().startOf("d"), dayjs().endOf("d")];
  const oneWeek: [Dayjs, Dayjs] = [
    dayjs().startOf("d").add(-7, "d"),
    dayjs().endOf("d"),
  ];
  const oneMonth: [Dayjs, Dayjs] = [
    dayjs().startOf("d").add(-30, "d"),
    dayjs().endOf("d"),
  ];
  const [fillteredDataList, setFillteredDataList] = useState<
    IReviewManageAdminResponse[]
  >([]);
  const [filterDateList, setFilterDateList] =
    useState<[Dayjs | null, Dayjs | null]>(all);
  const [filterSearch, setFilterSearch] = useState<string>("");
  const [filterCategory, setFilterCategory] =
    useState<TReviewFilterCategory>("program");
  const [isSwitch, setIsSwitch] = useState<boolean>(false);
  const [password, setPassword] = useState<string>("");
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const { data = [], isPending } =
    useGetAllReviewManageAdminResponse<IReviewManageAdminResponse[]>();
  const { message } = App.useApp();

  const onFilterDataList = () => {
    const fillterdData = data
      .sort(
        (a, b) =>
          dayjs(b.createdDate).valueOf() - dayjs(a.createdDate).valueOf()
      )
      .filter((q) => {
        const createdDate = dayjs(q.createdDate);
        const isInDateRange =
          (!filterDateList[0] || filterDateList[0].isBefore(createdDate)) &&
          (!filterDateList[1] || filterDateList[1].isAfter(createdDate));

        const matchesSearch =
          filterSearch === "" ||
          (filterCategory === "program" &&
            q.programTitle?.includes(filterSearch)) ||
          (filterCategory === "wellnessLecture" &&
            q.wellnessLectureName?.includes(filterSearch)) ||
          (filterCategory === "teacher" &&
            q.teacherName?.includes(filterSearch));

        const isVisible = isSwitch || !q.isPrivate;

        return isInDateRange && matchesSearch && isVisible;
      });
    setFillteredDataList(fillterdData);
  };

  const convertDataToCsvData = (data: IReviewManageAdminResponse[] = []) => {
    return data.map((q) => ({
      작성일: dayjs(q.createdDate).format("YYYY-MM-DD"),
      작성자: q.memberName,
      프로그램: q.isProgram ? q.programTitle : q.wellnessLectureName,
      "담당 코치": q.teacherName ?? "-",
      별점: q.rating.toFixed(1),
      "리뷰 내용": q.content,
      "이용 일시": dayjs(q.targetDateTime).format("YYYY.MM.DD HH:mm"),
      "이미지 링크": q.imageUrlList?.toString(),
    }));
  };

  const onOkSwitchModal = () => {
    if (password === "ReviewSwitch") {
      setIsOpenModal(false);
      setIsSwitch(true);
    } else {
      message.error("비밀번호가 틀렸습니다.");
    }
  };

  useEffect(() => {
    if (isPending) return;
    onFilterDataList();
  }, [isPending, filterDateList, filterSearch, filterCategory, isSwitch]);

  return (
    <>
      <div style={{ paddingBottom: "56px" }}>
        <div
          style={{ fontWeight: 700, fontSize: "18px", marginBottom: "17px" }}
        >
          리뷰 관리
        </div>

        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "center",
            paddingBottom: "24px",
          }}
        >
          <div
            style={{
              height: "32px",
              flex: 1,
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "32px",
            }}
          >
            작성 기간
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "16px",
              flex: 3,
            }}
          >
            <Radio.Group
              optionType="button"
              defaultValue={JSON.stringify(all)}
              value={JSON.stringify(filterDateList)}
              onChange={(q) =>
                setFilterDateList(
                  JSON.parse(q.target.value).map((w?: string) =>
                    w ? dayjs(w) : w
                  )
                )
              }
            >
              <Radio value={JSON.stringify(all)}>전체</Radio>
              <Radio value={JSON.stringify(today)}>오늘</Radio>
              <Radio value={JSON.stringify(oneWeek)}>7일</Radio>
              <Radio value={JSON.stringify(oneMonth)}>1개월</Radio>
            </Radio.Group>
            <DatePicker.RangePicker
              allowClear={false}
              value={filterDateList}
              onChange={(dates) =>
                setFilterDateList(
                  dates && dates[0] && dates[1] ? [dates[0], dates[1]] : oneWeek
                )
              }
            />
          </div>
        </div>

        <div style={{ display: "flex", paddingBottom: "24px" }}>
          <div
            style={{
              width: "50%",
              display: "flex",
              alignItems: "center",
              marginRight: "25px",
            }}
          >
            <div
              style={{
                flex: 1,
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "22px",
              }}
            >
              검색
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "16px",
                flex: 3,
              }}
            >
              <Select
                style={{ minWidth: "100px" }}
                value={filterCategory}
                onChange={(q) => setFilterCategory(q)}
                options={reviewFilterCategoryOptions}
              />
              <Input
                style={{ width: "100%" }}
                placeholder={
                  reviewFilterCategoryOptionsEnToKrMap[filterCategory] +
                  "명 검색"
                }
                value={filterSearch}
                onChange={(q) => setFilterSearch(q.target.value)}
                onPressEnter={onFilterDataList}
              />
            </div>
          </div>
          <Button type="primary" onClick={onFilterDataList}>
            검색
          </Button>
        </div>
      </div>

      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 32,
          }}
        >
          <div
            style={{ fontWeight: 700, fontSize: "14px", marginBottom: "10px" }}
          >
            검색 결과 ({fillteredDataList.length ?? 0})
          </div>
          <Switch
            defaultChecked={false}
            onChange={(i) => (i ? setIsOpenModal(i) : setIsSwitch(false))}
            checked={isSwitch}
          />
          <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
            <div style={{ color: "gray" }}>
              &#8251; 리뷰 이미지는 다운로드 시 파일에서 확인할 수 있습니다.
            </div>
            <Button>
              <CSVLink
                filename={"리뷰-" + dayjs().format("YYYY-MM-DD_HH_mm_ss")}
                data={convertDataToCsvData(fillteredDataList)}
              >
                CSV 다운로드
              </CSVLink>
            </Button>
          </div>
        </div>
        <Table
          dataSource={fillteredDataList}
          rowKey={(record: IReviewManageAdminResponse) =>
            record.wellnessLectureReviewId + record.programReviewId
          }
          columns={reviewManageColumns}
          loading={isPending}
        />
      </div>

      <Modal
        centered
        title="비공개 작성 포함"
        open={isOpenModal}
        onCancel={() => setIsOpenModal(false)}
        onOk={onOkSwitchModal}
        closeIcon={null}
      >
        <Input.Password
          value={password}
          onChange={(q) => setPassword(q.target.value)}
          placeholder="비밀번호를 입력해주세요."
        />
      </Modal>
    </>
  );
};

export default ReviewManage;
